export default {
  SET_EMPLOYEE_LIST: 'SET_EMPLOYEE_LIST',
  REMOVE_EMPLOYEE_FROM_LIST: 'REMOVE_EMPLOYEE_FROM_LIST',
  ADD_NEW_EMPLOYEE_TO_LIST: 'ADD_NEW_EMPLOYEE_TO_LIST',
  SET_EDITED_EMPLOYEE_IN_LIST: 'SET_EDITED_EMPLOYEE_IN_LIST',
  SET_EMPLOYEE_TO_BE_EDITED: 'SET_EMPLOYEE_TO_BE_EDITED'
};
